var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLargeComputer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "792px",
    height: "457px",
    viewBox: "0 0 792 457",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Live-Evaluation",
    transform: "translate(-404.000000, -3863.000000)",
    fillRule: "nonzero",
    fill: "#D0D5DC"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 3802.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1130,488.932343 L1130,91.1926075 C1130,69.368058 1120.33575,61 1098.45675,61 L503.786014,61 C481.907014,61 470,66.7699432 470,88.5944927 L470,488.932343 L1130,488.932343 Z M485.808185,91.7282462 L1114.19181,91.7282462 L1114.19181,463.141778 L485.808185,463.141778 L485.808185,91.7282462 Z M1196,493.664287 L1196,503.398572 C1196,511.465861 1178.279,518 1156.4,518 L443.6,518 C421.721,518 404,511.465861 404,503.398572 L404,493.664287 L734,493.664287 C734,497.022615 741.392,503.398572 750.5,503.398572 L849.5,503.398572 C858.608,503.398572 866,497.022615 866,493.664287 L1196,493.664287 Z",
    id: "Shape"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLargeComputer);
export default __webpack_public_path__ + "static/media/large-computer.0343d308e1fc2b35081f705021fb8f7c.svg";
export { ForwardRef as ReactComponent };